import '@awesome.me/webawesome/dist/components/button/button.js';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface BrainDumpProps {
  onSubmit: (rawText: string) => void;
  isProcessing: boolean;
}

export function BrainDump({ onSubmit, isProcessing }: BrainDumpProps) {
  const { t } = useTranslation();
  const [text, setText] = useState('');

  const handleSubmit = () => {
    if (text.trim().length > 0) {
      onSubmit(text.trim());
    }
  };

  return (
    <div
      style={{
        maxWidth: '480px',
        width: '100%',
        margin: '0 auto',
        padding: 'var(--space-xl)',
      }}
    >
      <h2
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: '1.5rem',
          marginBottom: 'var(--space-lg)',
        }}
      >
        {t('onboarding:braindump.title')}
      </h2>

      <textarea
        value={text}
        onChange={e => { setText(e.target.value); }}
        placeholder={t('onboarding:braindump.placeholder')}
        disabled={isProcessing}
        rows={10}
        style={{
          width: '100%',
          background: 'var(--color-card)',
          border: '1px solid var(--color-card-border)',
          borderRadius: 'var(--radius-md)',
          padding: 'var(--space-md)',
          color: 'var(--color-text-primary)',
          fontSize: '1rem',
          resize: 'vertical',
          lineHeight: '1.6',
        }}
      />

      <div style={{ marginTop: 'var(--space-lg)', textAlign: 'right' }}>
        <wa-button
          variant="brand"
          onClick={handleSubmit}
          disabled={isProcessing || text.trim().length === 0}
        >
          {isProcessing ? t('capture:quickAdd.processing') : t('onboarding:braindump.submit')}
        </wa-button>
      </div>
    </div>
  );
}
